var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-jumbotron',{attrs:{"src":"/static/404-soft.jpg","height":"1000px","dark":""}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',{attrs:{"text-xs-center":""}},[_c('h3',{staticClass:"display-3"},[_vm._v("What you're looking for can't be found")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-759eed56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/NotFound.vue
// module id = PaEh
// module chunks = 1